/**
 * $TODO: Rename OfficeThemeMode to HarmonyThemeMode
 */
export var OfficeThemeMode;
(function (OfficeThemeMode) {
    OfficeThemeMode["default"] = "default";
    OfficeThemeMode["dark"] = "dark";
    OfficeThemeMode["highContrast"] = "contrast";
})(OfficeThemeMode || (OfficeThemeMode = {}));
//# sourceMappingURL=officeStartTheme.js.map